import {
  CheckoutRecord,
  DamagedEquipmentRecord,
  EquipmentAsset,
  Reservation
} from '../models/equipment.models';

export const MOCK_EQUIPMENT_ASSETS: EquipmentAsset[] = [
  {
    id: '1',
    assetId: 'PRJ-102',
    name: 'Epson Projector',
    serialNumber: 'SN-8892-XP',
    category: 'AV Equipment',
    location: 'Warehouse A',
    status: 'available',
    condition: 'good',
    icon: 'bi-projector'
  },
  {
    id: '2',
    assetId: 'SS-003',
    name: 'JBL Sound System',
    serialNumber: 'SN-4412-JBL',
    category: 'Audio',
    location: 'Warehouse A',
    status: 'checked-out',
    condition: 'good',
    icon: 'bi-speaker'
  },
  {
    id: '3',
    assetId: 'VAN-007',
    name: 'Mercedes Sprinter',
    serialNumber: 'SN-MS-2024',
    category: 'Vehicle',
    location: 'Garage B',
    status: 'in-repair',
    condition: 'fair',
    icon: 'bi-truck'
  },
  {
    id: '4',
    assetId: 'CAM-015',
    name: 'Canon DSLR Camera',
    serialNumber: 'SN-7788-DSLR',
    category: 'Photography',
    location: 'Warehouse B',
    status: 'available',
    condition: 'good',
    icon: 'bi-camera'
  },
  {
    id: '5',
    assetId: 'CHR-022',
    name: 'Folding Chair Set',
    serialNumber: 'SN-CHR-022',
    category: 'Furniture',
    location: 'Warehouse A',
    status: 'checked-out',
    condition: 'good',
    icon: 'bi-easel'
  }
];

export const MOCK_RESERVATIONS: Reservation[] = [
  {
    id: '1',
    reservationNumber: 'RES-2026-0045',
    customer: 'Mokoena Events',
    equipment: 'JBL Sound System',
    startDate: '2026-06-28',
    endDate: '2026-06-29',
    status: 'confirmed'
  },
  {
    id: '2',
    reservationNumber: 'RES-2026-0046',
    customer: 'Corporate Training Team',
    equipment: 'Epson Projector',
    startDate: '2026-07-02',
    endDate: '2026-07-02',
    status: 'pending'
  }
];

export const MOCK_CHECKOUTS: CheckoutRecord[] = [
  {
    id: '1',
    checkoutNumber: 'CHK-2026-0112',
    customer: 'Sandton Conference Centre',
    equipment: 'JBL Sound System',
    checkoutDate: '2026-06-20',
    dueDate: '2026-06-27',
    status: 'overdue'
  },
  {
    id: '2',
    checkoutNumber: 'CHK-2026-0113',
    customer: 'Rosebank Branch',
    equipment: 'Folding Chair Set',
    checkoutDate: '2026-06-24',
    dueDate: '2026-06-30',
    status: 'active'
  }
];

export const MOCK_DAMAGED_EQUIPMENT: DamagedEquipmentRecord[] = [
  {
    id: '1',
    reportNumber: 'DMG-2026-0008',
    equipment: 'Mercedes Sprinter',
    reportedDate: '2026-06-22',
    damageType: 'damaged',
    status: 'under-review',
    estimatedCost: 18500
  },
  {
    id: '2',
    reportNumber: 'DMG-2026-0009',
    equipment: 'Wireless Microphone Set',
    reportedDate: '2026-06-10',
    damageType: 'lost',
    status: 'open',
    estimatedCost: 3200
  }
];
